import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {API_URL} from '../../../constants';
import ModalFile from '../../Partials/ModalFile';
import Error from '../../Error/error';
import {showModalPageClass, hideLoader, hideModalPageClass, setTextInputLongitud, generateSlugAutomatico, setTestData, setDataForm} from '../../../functions';
import axios from 'axios';
import {Editor} from 'react-draft-wysiwyg';
import {stateToHTML} from 'draft-js-export-html';
import {convertFromHTML, EditorState, ContentState} from 'draft-js';
import {BASE_URL_PAIS} from '../../../constants';

import CKEditor from 'ckeditor4-react';
import { ckeditorconfig } from '../../functions/functions';
import { cacheConfig, generateLabel, getFrontPageUrl } from '../../../utils/functions';

export default class FichaPaisEditar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fichaPais: {
                estado:             false,
            },
            key: "0",
            response:   [], 
            loadData:   true,
            datosEconomicos: [],
            etiquetaSeleccionada: "",
            contenidoSeleccionado: "",
            guardando: false,
            sectores: [],
            Validacion: {
                CeldaValor1: {
                    Error: false,
                    RequeridoError: "El campo código es requerido."
                },
                nombrePais: {
                    Error: false,
                    RequeridoError: "El campo nombre es requerido."
                },
                fpai_Slug: {
                    Error: false,
                    RequeridoError: "El campo Slug es requerido."
                },
                CeldaValor2: {
                    Error: false,
                    RequeridoError: "El campo continente es requerido."
                },
            }
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.onEditorChange     = this.onEditorChange.bind(this);
    }

    deleteCache = async (slug, paisCodigo) => {
        // alert("deleteCache: "  + slug +  ' ' +  paisCodigo)

        // // const baseUrl   = getFrontPageUrl();
        // // // const urldeleteCache = `${baseUrl}/cache/limpiar-ficha-pais?slug=${slug}&paisCodigo=${paisCodigo}`;
        // // const urldeleteCache = `${baseUrl}/WebUX/ObtenerPaisIndicador/${slug}`;
        // // axios.delete(
        // //     urldeleteCache, 
        // //     cacheConfig
        // // ).then((res) => {

        // //     console.log("delete Cache response:" , res.data.message);
        // //     console.log(res.data);

        // // }).catch((err) => {
        // //     console.error(err);
        // // });

        try {
            const baseUrl = getFrontPageUrl();
            if (!baseUrl) {
                console.error("Error: baseUrl es indefinido.");
                return;
            }
    
            // URLs a limpiar
            const urlsToClear = [
                `${baseUrl}/cache/limpiar-ficha-pais?slug=${slug}&paisCodigo=${paisCodigo}`,
                `${baseUrl}/WebUX/ObtenerPaisIndicador/${slug}`,
                `${baseUrl}/WebUX/ObtenerFichaPais/${paisCodigo}`,
                `${baseUrl}/WebUX/ObtenerParametrosPorCodigo/FICHATIT`,
                `${baseUrl}/WebUX/ObtenerParametrosPorCodigo/FICHASUBTIT`,
                `${baseUrl}/WebUX/ObtenerParametrosPorCodigo/PORTADA_FICHA`,
                `${baseUrl}/WebUX/ObtenerParametrosPorCodigo/FPRO`,
                `${baseUrl}/WebUX/ObtenerParametrosPorCodigo/FPAR`,
                `${baseUrl}/WebUX/ObtenerReportePaisParaGraficos/EVO/${paisCodigo}`,
                `${baseUrl}/WebUX/ObtenerReportePaisParaGraficos/SEC/${paisCodigo}`,
                `${baseUrl}/WebUX/ObtenerReportePaisParaGraficos/PRE/${paisCodigo}`,
                `${baseUrl}/WebUX/ObtenerReportePaisParaGraficos/PAR/${paisCodigo}`,
                `${baseUrl}/WebUX/ObtenerReportePaisParaGraficos/REG/${paisCodigo}`,
                `${baseUrl}/WebUX/ObtenerReportePaisParaGraficos/EMP/${paisCodigo}`,
                `${baseUrl}/WebUX/ListarFuenteGraficos?grupo=PAIS`
            ];
    
            // Enviar múltiples peticiones DELETE
            const deleteRequests = urlsToClear.map(url => axios.delete(url, { headers: { "Cache-Control": "no-store" } }));
            await Promise.all(deleteRequests);
    
            console.log("Caché eliminada correctamente.");
        } catch (error) {
            // console.log("Error al eliminar caché: " + error.response?.data || error.message);
            console.log("Error al eliminar caché: " + error.message);
            console.log( error );
        }        
    }

    handleClickGuardar(e) {
        e.preventDefault();

        if(this.state.guardando == false){
            this.setState({ guardando: true });
            const me = this;
    
            const url = `${API_URL}FichaPaisUX/Actualizar`;
            let fichaPais = {...this.state.fichaPais};
            
            setDataForm(fichaPais);
            fichaPais["usuarioEdicion"] = cookie.load('user').nUsuCodigo;
            fichaPais['estado'] = Number(fichaPais['estado']); 

            let newState = this.state;
            let hasError = false;
            
            //codigo de pais:
            if (fichaPais.CeldaValor1 =='' || fichaPais.CeldaValor1 == null) {
                newState.Validacion.CeldaValor1.Error = true;
                toast.error("" + newState.Validacion.CeldaValor1.RequeridoError);
                hasError = true;
            }

            if (fichaPais.nombrePais == '' || fichaPais.nombrePais == null) {
                newState.Validacion.nombrePais.Error = true;
                toast.error("" + newState.Validacion.nombrePais.RequeridoError);
                hasError = true;
            }
            
            if (fichaPais.fpai_Slug == '' || fichaPais.fpai_Slug == null) {
                newState.Validacion.fpai_Slug.Error = true;
                toast.error("" + newState.Validacion.fpai_Slug.RequeridoError);
                hasError = true;
            }
            
            if(hasError){
                this.setState(newState);
                return;
            }
            // fichaPais["datosEconomicos"] = this.state.datosEconomicos;

            let paisCodigo  = fichaPais.paisCodigo;
            let slug        = fichaPais.fpai_Slug;

            axios.post(url, JSON.stringify(JSON.stringify(fichaPais)),
            { 
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                }
            }).then((data)=> {
                me.setState({ guardando:false });
                if(data.data.result.status){
                    this.deleteCache(slug, paisCodigo);
                        this.props.history.push({pathname: '/ficha-pais'});
                }else{
                    toast.error(data.data.result.error);
                    console.log("zzz")
                }
            }).catch((error)=> {
                toast.error('Error no controlado.');
                me.setState({ guardando:false });
            });
        }
    }

    handleClickCancel(e) {
        this.props.history.push({
            pathname: '/ficha-pais'
        });
    }

    handleInputChange(event){
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        if(target.id == 'fpai_Slug'){
            let validaciones = this.state.Validacion;
            validaciones[target.id].Error = false;
            this.setState({
                Validacion: validaciones
            });
        }
    }

    showModalFile = (clase = "") => {
        showModalPageClass(clase);
    }
 
    onSelectArchivo(fileName, fileData, fieldName, fieldNameData){
        let fichaPais = {... this.state.fichaPais};
        fichaPais[fieldName] = fileName;
        fichaPais[fieldNameData] = fileData;

        document.getElementById(fieldName).value = fileName;

        this.setState({
            fichaPais
        });

        // if(fieldName == "bandera"){
        //     let validaciones = this.state.Validacion;
        //     validaciones[fieldName].Error = false;
        //     this.setState({
        //         Validacion: validaciones,
        //         miniaturaBandera: fileData
        //     }); 
        // }

        // if(fieldName == "mapa"){
        //     let validaciones = this.state.Validacion;
        //     validaciones[fieldName].Error = false;
        //     this.setState({
        //         Validacion: validaciones,
        //         miniaturaMapa: fileData
        //     }); 
        // }

        if(fieldName == "imagenSEO"){
            this.setState({
                miniaturaImagenSEO: fileData
            }); 
        }

        hideModalPageClass(`div${fieldName}Upload`);
    }

    checkedValidate = (item) => {
        let fichaPais = this.state.fichaPais;
        fichaPais[item] = !fichaPais[item];

        this.setState({
            fichaPais
        });
    }

    onTituloChange(){
        let CeldaValor1 = document.getElementById('CeldaValor1').value;
        let nombrePaisVal = document.getElementById('nombrePais').value;

        let validaciones = this.state.Validacion;
        validaciones['CeldaValor1'].Error = false;
        validaciones['nombrePais'].Error = false;
        validaciones['fpai_Slug'].Error = false;

        this.setState({
            Validacion: validaciones
        });

        document.getElementById('tituloSEO').value = nombrePaisVal;
        document.getElementById('enlaceSEO').value = generateSlugAutomatico(nombrePaisVal);
        document.getElementById('fpai_Slug').value = generateSlugAutomatico(nombrePaisVal);
        setTextInputLongitud(['fpai_Slug', 'enlaceSEO', 'tituloSEO', 'CeldaValor1']);
    }

    componentDidMount(){
        localStorage.setItem("load", false);
        let params = this.props.match.params;
        var key = params.id;
        this.state.key = key;

        const url = `${API_URL}FichaPaisUX/ObtenerPorId?id=${key}`;
        axios.get(url)
            .then(response => response.data)
            .then((data) => {
                hideLoader();
                let dataFichaPais = data.result.data;
                // console.log(dataFichaPais)
                dataFichaPais['estado'] = Boolean(dataFichaPais['estado'] === '1');

                this.setState({ 
                    fichaPais:  dataFichaPais,
                    response:   data, 
                    loadData:   false,
                });

                setTimeout(() => {
                    // setTextInputLongitud(['nombrePais', 'fpai_Slug', 'CeldaValor1','CeldaValor2',  'tituloSEO', 'descripcionSEO', 'enlaceSEO', 'script']);
                    setTextInputLongitud(['nombrePais', 'fpai_Slug', 'CeldaValor2',  'tituloSEO', 'descripcionSEO', 'enlaceSEO', 'script']);
                }, 200);
               
            })
            .catch(error => {
                hideLoader();
                console.log("Error al obtener el registro de Mercado: ", error);
                toast.error('Error al obtener el registro de Mercado');
            });
    }

    onEditorChange( editor ) {
        let copyState = this.state.fichaPais;
        this.setState({
            fichaPais: copyState
        });
    }

    render() {
        return (
            (this.state.response.statusCode === 200 && !this.state.loadData)?
            <div className="">
               <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                        <a href="/">
                            / Panel de configuración general
                        </a>
                        <Link to="/ficha-pais">
                            / Ficha Mercado
                        </Link>
                        <span> / Editar Ficha de Mercado</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Editar Ficha de Mercado
                </div>
                <div className="div_Modulos_Noticias">
                    <div className="div_WrapperEditarPagina">
                        CÓDIGO DE PAÍS:
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Codigo ISO país" id='CeldaValor1' maxLength={3} readOnly defaultValue={this.state.fichaPais.celdaValor1} className={`data-test data-form ${this.state.Validacion.CeldaValor1.Error ? "error" : ""}` } style={{background:'#d8d8d8'}} />
                            <span id="longitudCeldaValor1"></span>
                        </div>
                        CONTINENTE:
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Continente" id='CeldaValor2' maxLength={50} readOnly defaultValue={this.state.fichaPais.celdaValor2} style={{background:'#d8d8d8'}} />
                            <span id="longitudCeldaValor2"></span>
                        </div>
                        NOMBRE DE MERCADO:
                        <div className="txtFile x-1">
                            <input type="text" placeholder="Nombre" id='nombrePais' maxLength={255} onChange={() => this.onTituloChange()} defaultValue={this.state.fichaPais.nombrePais}  className={`data-test data-form ${this.state.Validacion.nombrePais.Error ? "error" : ""}`}/>
                            <span id="longitudnombrePais"></span>
                        </div>
                        <div className="txtFile x-1">
                            SLUG:
                            <input type="text" placeholder="Slug" id='fpai_Slug' defaultValue={this.state.fichaPais.fpai_Slug} maxLength={255} onChange={this.handleInputChange} 
                            className={`data-test data-form ${this.state.Validacion.fpai_Slug.Error ? "error" : ""}`}/>
                            <span id="longitudfpai_Slug"></span>
                        </div>

                        <div className="divWrapperActive" style={{ maxWidth: 215 }}>
                            <div>
                                <span>Habilitado</span>
                            </div>
                            <div>
                                <div 
                                    className={this.state.fichaPais.estado ? "containerActive backgroundPosition" : "containerActive"} 
                                    onClick={() => this.checkedValidate("estado")}
                                >
                                    <div className={this.state.fichaPais.estado ? "actionActive leftPosition" : "actionActive"}/>
                                </div>
                                <span>
                                    {this.state.fichaPais.estado ? "Activado" : "Desactivado"}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="clear"></div>

                    <div className="divModulo_Seo">
                        <h2>Configuración <strong>SEO</strong></h2>
                        <div className="divWrapperModulo_Seo">
                            <div className="txtFile x-1">
                                <input type="text" placeholder="SEO Título" id='tituloSEO' maxLength="255" defaultValue={this.state.fichaPais.tituloSEO} className="data-test data-form"/>
                                <span id="longitudtituloSEO"></span>
                            </div>
                            <div className="txtFile x-1">
                                <textarea placeholder="SEO Descripción" id='descripcionSEO' maxLength="255" defaultValue={this.state.fichaPais.descripcionSEO} style={{height:"100px"}} className="data-test data-form"/>
                                <span id="longituddescripcionSEO"></span>
                            </div>
                            <div className="txtFile x-1 relative">
                                <span className="subirImagen" onClick={() => this.showModalFile("divImagenSEOUpload")} />
                                <input type="text" placeholder="SEO Imagen" id='imagenSEO' defaultValue={this.state.fichaPais.imagenSEO} className='data-test data-form' maxLength={255}/>
                            </div>
                            <div className='row w-100 justify-content-end'>
                            <div className="col-md-12 p-2 text-center">
                                <div>
                                    {!this.state.miniaturaImagenSEO
                                        ? (
                                        <div>
                                            <p>No se ha seleccionado ninguna imagen.</p>
                                        </div>)
                                        : (
                                        <div>
                                            <img className="col-md-6"
                                            src={(this.state.miniaturaImagenSEO.startsWith('http') || this.state.miniaturaImagenSEO.startsWith('data:image')) ? this.state.miniaturaImagenSEO :  (BASE_URL_PAIS + this.state.miniaturaImagenSEO)} />
                                            <br/><br/>  
                                        </div>
                                        )
                                    }
                                </div>
                            </div>
                            </div>
                            <div className="txtFile x-1">
                                <input type="text" placeholder="Enlace" id='enlaceSEO' maxLength="255" defaultValue={this.state.fichaPais.enlaceSEO} className="data-test data-form"/>
                                <span id="longitudenlaceSEO"></span>
                            </div>
                            <div className="divWrapperActive">
                                <div>
                                    <span>Motores de busqueda <br />seguir enlaces</span>
                                </div>
                                <div>
                                    <div className={this.state.fichaPais.seguirBuscadoresSEO ? "containerActive backgroundPosition" : "containerActive"} onClick={() => this.checkedValidate("seguirBuscadoresSEO")}>
                                        <div className={this.state.fichaPais.seguirBuscadoresSEO ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.fichaPais.seguirBuscadoresSEO ? "Activado" : "Desactivado"}</span>
                                </div>
                                <div>
                                    <span>Mostrar Pagina <br />Motores de Búsqueda </span>
                                </div>
                                <div>
                                    <div className={this.state.fichaPais.mostrarBuscadoresSEO ? "containerActive backgroundPosition" : "containerActive"} onClick={() => this.checkedValidate("mostrarBuscadoresSEO")}>
                                        <div className={this.state.fichaPais.mostrarBuscadoresSEO ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.fichaPais.mostrarBuscadoresSEO ? "Activado" : "Desactivado"}</span>
                                </div>
                            </div>
                            <div className="txtFile x-1">
                                <textarea placeholder="Pegue aquí su código JavaScript" id="script" style={{height:"100px"}} maxLength="32000" defaultValue={this.state.fichaPais.script} className="data-test data-form"/>
                                <span id="longitudscript"></span>
                            </div>
                        </div>
                    </div>
                    <div className="divContenedorBtn_Noticias">
                        <a 
                            href="#" 
                            className="btnActivo" 
                            onClick={(event) => this.handleClickGuardar(event)}
                        >
                            {this.state.guardando ? 'PROCESANDO...' : 'GUARDAR'}
                        </a>
                        {/* <a href="#" className="btnActivo" onClick={(event) => this.prueba(event)}>{this.state.guardando ? 'PROCESANDO...' : 'GUARDAR'}</a> */}
                        <a href="#" onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <ModalFile class={"divImagenSEOUpload"} onSelect={(filename, data) => this.onSelectArchivo(filename, data, "imagenSEO", "imagenSEOData")} tipo="image"/>
            </div>
            :
            
            <Error StatusCode="500" StatusMessage="Error"></Error>
        )
    }
}